import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import Carousel from '../Carousel';
import Title from '../Title';
import Logo from '../Logo';
import styles from './DetailModal.css';

const InformationRow = ({ label, value }) => (
  <div className={styles.infoRow}>
    <div className={styles.infoRowLabel}>{label}</div>
    <div className={styles.infoRowValue}>{value}</div>
    <div className="clearfix" />
  </div>
);

class Description extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      expand: false,
      needExpansion: false,
    };
  }

  render() {
    return (
      <div className="row">
        <div className="col-xs-12">
          <div
            className={
              this.state.expand
                ? styles.descriptionExpand
                : styles.descriptionCollapse
            }
            ref={ref => {
              this.descriptionRefWrapper = ref;
            }}
          >
            <p
              ref={ref => {
                this.descriptionRef = ref;
              }}
            >
              {this.props.description}
            </p>
          </div>
        </div>
        {this.state.needExpansion && (
          <div className="col-xs-12">
            <div className="pull-right">
              <a onClick={this._onClickReadMore} href="javascript:void(0)">
                {!this.state.expand && (
                  <span className="fa fa-angle-double-down" />
                )}
                {this.state.expand && (
                  <span className="fa fa-angle-double-up" />
                )}
                &nbsp; {this.state.expand && 'Read less'}{' '}
                {!this.state.expand && 'Read more'}
              </a>
            </div>
          </div>
        )}
      </div>
    );
  }

  componentDidMount() {
    const rectWrapper = this.descriptionRefWrapper.getBoundingClientRect();
    const rectDesc = this.descriptionRef.getBoundingClientRect();
    if (rectWrapper.height < rectDesc.height && !this.state.needExpansion) {
      this.setState({
        needExpansion: true,
      });
    }
  }

  _onClickReadMore = () => this.setState({ expand: !this.state.expand });
}

class DetailModal extends React.PureComponent {
  render() {
    const { app, show } = this.props;
    return (
      <Modal show={show}>
        <Modal.Body>
          <span
            className={`${styles.close} fa fa-close`}
            onClick={this._onClickClose}
          />
          <div className={styles.wrapper}>
            <div className={`row no-margin ${styles.headerWrapper}`}>
              <div className={styles.headerImageWrapper}>
                <Logo
                  src={app.logo.url || 'http://via.placeholder.com/350x350'}
                />
              </div>
              <div className={styles.headerTitleWrapper}>
                <div className={styles.headerTitle}>{app.name}</div>
                {this._isDefinedPrice(app) && (
                  <div>
                    <b>{this._price(app)}</b>&nbsp;
                    <span>per month</span>
                  </div>
                )}
              </div>
              <div className={styles.headerButtonWrapper}>
                <button
                  className={`btn btn-primary`}
                  onClick={this._onClickGetStarted}
                >
                  Get Started
                </button>
              </div>
            </div>
            <Carousel
              images={app.oauth_application_images.map(img => img.image.url)}
              wrapperClassName={styles.carouselWrapper}
            />
            <Title title="Description" titleSize="18px" />
            <Description description={app.description} />
            <Title title="Information" titleSize="18px" />
            <div className="row">
              {this._isDefinedPrice(app) && (
                <InformationRow label="Pricing" value={this._price(app)} />
              )}
              <InformationRow
                label="Website"
                value={<a href={this._website(app)}>{app.website}</a>}
              />
              <InformationRow
                label="Support Email"
                value={
                  <a href={`mailto:${app.support_email}`}>
                    {app.support_email}
                  </a>
                }
              />
              <InformationRow label="Phone" value={app.support_phone} />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  _website = app => {
    if (
      app.website.startsWith('http://') ||
      app.website.startsWith('https://')
    ) {
      return app.website;
    }
    return `https://${app.website}`;
  };

  _isDefinedPrice = app => {
    return !!app.price || app.price === 0;
  };

  _price = app => {
    return app.price || 'no price available';
  };

  _onClickClose = () => {
    this.props.onClickClose({});
  };

  _onClickGetStarted = () => {
    const { app } = this.props;
    this.props.onClickGetStarted({ app });
  };
}

DetailModal.propTypes = {
  show: PropTypes.boolean,
  app: PropTypes.object,
  onClickClose: PropTypes.func,
  onClickGetStarted: PropTypes.func,
};

export default DetailModal;
